module.exports = __webpack_public_path__ + "b3f8346bca34c3333e5757db3b3e9033.otf";